import { Context } from '@nuxt/types'
import { Inject } from '@nuxt/types/app'

import Vue from 'vue'
import WebSocketManager from './manager'

// Example Usage

// mounted() {
//   this.$socket.$on(<event-name>, (data) => {
//     console.log(`got ${data} from WebSocket`)
//   })
// }
//
// Sending message
// this.$socketManager.send({ event: 'socket', data: 'Hello' })

declare module '@nuxt/types' {
  interface NuxtConfig {
    $socket: Vue
    $socketManager: WebSocketManager
  }
}

declare module 'vue/types/vue' {
  interface Vue {
    $socket: Vue
    $socketManager: WebSocketManager
  }
}

const reconnectInterval = Number('<%= options.reconnectInterval %>') || 1000
const urlFromOptions = '<%= options.url %>'

export default ({ app, $sentry }: Context, inject: Inject): void => {
  const runtimeConfig = app.$config?.websocket || {}
  const url = runtimeConfig.url || urlFromOptions

  if (!url) {
    $sentry.captureMessage(
      'WebSocket connection URL is required. Please specify it via options or runtime configuration.'
    )
  }

  const emitter = new Vue()
  const manager = new WebSocketManager(url, emitter, reconnectInterval)

  inject('socket', emitter)
  inject('socketManager', manager)
}
